export { default } from "../.internal/themes/animated";


// WEBPACK FOOTER //
// ../../../src/themes/animated.ts